import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConfigService } from "./config.service";

export interface ExistingEmailResponse {
  existingCustomer: boolean;
  orderHistoryAmount: number;
  cannotTakeAdvantage?: boolean;
}

export const CheckExistingEmailEndpoint = "profile?email=";

@Injectable({
  providedIn: "root",
})
export class EmailService {
  loginEmail: string;
  private customerUrl: string;

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient
  ) {}

  checkExistingEmail(email: string): Observable<any[]> {
    this.customerUrl =
      this.configService.getConfiguration().apiUrlData.customer;

    return this.httpClient.post<any[]>(
      this.customerUrl + "CheckForDuplicateEmail",
      { Email: email }
    );
  }
}
